"use strict";

exports.__esModule = true;
exports.getImageUrl = getImageUrl;
exports.getImageFilename = void 0;

var _constants = require("./constants");

var _require = require('lodash'),
    min = _require.min;

var blurParam = function blurParam(blur) {
  return blur > 0 ? "blur_" + blur + "," : '';
};

var getImageFilename = function getImageFilename(pathname) {
  return pathname ? pathname.replace(/^media\//, '') : '';
};

exports.getImageFilename = getImageFilename;

function getImageUrl(imageHost) {
  return function produceImage(_temp, _temp2) {
    var _ref = _temp === void 0 ? {} : _temp,
        fileName = _ref.file_name,
        actualWidth = _ref.width,
        actualHeight = _ref.height;

    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$maxWidth = _ref2.maxWidth,
        maxWidth = _ref2$maxWidth === void 0 ? 1000 : _ref2$maxWidth,
        _ref2$maxHeight = _ref2.maxHeight,
        maxHeight = _ref2$maxHeight === void 0 ? 1000 : _ref2$maxHeight,
        _ref2$quality = _ref2.quality,
        quality = _ref2$quality === void 0 ? 80 : _ref2$quality,
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? _constants.TRANSFORM_TYPE_FIT : _ref2$type,
        _ref2$format = _ref2.format,
        format = _ref2$format === void 0 ? 'png' : _ref2$format,
        _ref2$blur = _ref2.blur,
        blur = _ref2$blur === void 0 ? 0 : _ref2$blur;

    if (fileName) {
      var _ref3 = [min([maxWidth, actualWidth]), min([maxHeight, actualHeight])],
          width = _ref3[0],
          height = _ref3[1];
      return "https://" + imageHost + "/media/" + fileName + "/v1/" + type + "/w_" + width + ",h_" + height + "," + blurParam(blur) + "al_c,q_" + quality + "/file." + format;
    }

    return '';
  };
}